import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient) { }

  getCountries() {
    return this.http.get(`${environment.ADMIN_BASE_URL}/countries`).pipe(retry(3));
  }

  login(loginDetails) {
    return this.http.post(`${environment.API_URL}/login`, loginDetails).pipe(retry(3));
  }

  generateOtp(credentials: { email: string, password: string }) {
    return this.http.post(`${environment.API_URL}/generate-otp`, credentials);
  }
  setNewPassword(payload) {
    return this.http
      .put(`${environment.API_URL}/merchant/user/updatepassword`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('resetToken')}`
        }
      })
      .pipe(retry(3));
  }

  fetchAuthUser() {
    return this.http.get(`${environment.ADMIN_BASE_URL}/auth/user`).pipe(retry(3));
  }

  fetchEntityTypes = (country_code) => {
    let params = new HttpParams();
    params = params.append('country_code', country_code);
    return this.http.get(`${environment.API_URL2}/transactions-service/ent`, { params });
  };

  fetchBusinessTypes = () => this.http.get(`${environment.API_URL}/business/type`).pipe(retry(3));

  runKyc = (payload: any): Observable<any> => this.http.post(`${environment.API_URL2}/user-service/verification/image-kyc`, payload);

  fetchTransactionTypes = () => this.http.get(`${environment.API_URL}/business/transactions/type`).pipe(retry(3));

  createMerchant = (requestBody) => this.http.post(`${environment.API_URL}/merchants`, requestBody);

  updateUtilityMerchant = (requestBody, id): Observable<any> =>
    this.http.put(`${environment.API_URL2}/transactions-service/merchant/${id}`, requestBody).pipe(retry(3));

  getCompanyProfile = (companyNumber) =>
    this.http.get(
      `${environment.API_URL2}/user-service/business/company-profile?companyNumber=${companyNumber}&countryCode=GB`
    );

  requestPasswordRequest = (payload) => this.http.post(`${environment.API_URL2}/xas/v1/merchant/accounts/password/reset-request`, payload).pipe(retry(2))
  resetPassword = (payload) => this.http.post(`${environment.API_URL2}/xas/v1/merchant/accounts/password/reset`, payload).pipe(retry(2))

  // private encodeCredentials(username: string, password: string): string {
  //   const utf8Bytes = new TextEncoder().encode(`${username}:${password}`);
  //   let binary = '';
  //   utf8Bytes.forEach((byte) => (binary += String.fromCharCode(byte)));
  //   return btoa(binary);
  // }

  verifyGhanaCard = (payload: FormData): Observable<any> => {
    const headers = new HttpHeaders()
      // .set('X-API-NAME', environment.GHANA_CARD_API_NAME)
      // .set('X-API-PASSWORD', environment.GHANA_CARD_API_PASSWORD)
      .set('Accept', 'application/json');
    return this.http.post(environment.GHANA_CARD_API_URL, payload, { headers });
  }
}